import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { ButtonFavorite } from '@lean-body/components/atoms/button_favorite';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles/variables';
export const FavoriteWithCount = (props) => {
    const { favCount, isStoppedFav, onClick, classObject } = props;
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement(ButtonFavorite, { onClick: onClick, isStopped: isStoppedFav }),
        React.createElement("span", { className: css(styles.countText) }, favCount)));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        alignItems: 'center',
        gap: 5,
    },
    countText: {
        fontSize: 12,
        fontWeight: 'bold',
        color: Colors.Black,
        [MediaBreakPointUp.MD]: {
            fontSize: 14,
            margin: 0,
        },
    },
});
